import React from 'react';
import { HeartIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { StaggerTitle } from './ui/StaggerTitle';
import { useParallax } from '../hooks/useParallax';
import { heroServices, contact } from '../data/site';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/c771ae72-93ab-4bd2-9e84-2d00e6855d29.jpg';
export function Hero() {
  const {
    containerRef,
    targetRef
  } = useParallax<HTMLElement, HTMLImageElement>(70);
  return <section id="hero" ref={containerRef} className="relative isolate flex min-h-[100svh] items-end overflow-hidden bg-black pb-10 pt-40 sm:pb-14 sm:pt-48" data-id="element-26" data-mp="xanq434vpngy">
      <img ref={targetRef} src={HERO_IMAGE} alt="Manos sosteniendo velas encendidas e incienso en la oscuridad" width={1376} height={774} loading="eager" fetchPriority="high" decoding="async" className="absolute inset-0 -z-20 h-[112%] w-full object-cover object-center" data-id="element-27" data-mp="sd48ct8z2sk9" />
      <div className="absolute inset-0 -z-10" style={{
      background: 'linear-gradient(180deg, rgba(0,0,0,0.92) 0%, rgba(10,0,0,0.6) 35%, rgba(140,8,4,0.55) 72%, rgba(17,17,17,0.97) 100%)'
    }} aria-hidden="true" data-id="element-28" data-mp="3j9u1r1hjpsmv" />

      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-29" data-mp="3e8wjyq0g70lw">
        <Reveal data-id="element-30" data-mp="3ebiqqnfilc32">
          <p className="mb-5 inline-flex items-center gap-2 font-sans text-xs font-semibold tracking-[0.3em] text-white/70" data-id="element-31" data-mp="30i19586e29fo">
            <HeartIcon className="h-3.5 w-3.5 text-brand-red" aria-hidden="true" data-id="element-32" data-mp="358zq89z7bbjz" />
            MAESTROS ESPIRITUALES
          </p>
        </Reveal>

        <StaggerTitle as="h1" text="AMARRES Y ENCANTAMIENTOS DE AMOR" className="glow-red max-w-4xl font-display text-[15vw] leading-[0.86] text-brand-red sm:text-[10vw] lg:text-[8.5rem]" data-id="element-33" data-mp="2qhqtzi0smrxv" />

        <Reveal delay={0.08} data-id="element-34" data-mp="2lkimcbd9u6av">
          <p className="mt-6 max-w-2xl font-sans text-lg leading-relaxed text-white sm:text-xl" data-id="element-35" data-mp="2ljpa4uvjmolc">
            Consulta con nosotros y recibe orientación espiritual para lograr lo
            que deseas.
          </p>
        </Reveal>

        <Reveal delay={0.14} data-id="element-36" data-mp="na09x0zpb7f8">
          <ul className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2 font-sans text-[11px] font-semibold tracking-[0.18em] text-white/85 sm:text-sm" data-id="element-37" data-mp="ic891hh2wayw">
            {heroServices.map((service, i) => <li key={service} className="flex items-center gap-3" data-id="element-38" data-mp="1b0nilohfy12u" data-mpi={i}>
                <span data-id="element-39" data-mp="1ayt6mzo5djaw">{service}</span>
                {i < heroServices.length - 1 && <span className="text-brand-red" aria-hidden="true" data-id="element-40" data-mp="162m47guympxp">
                    |
                  </span>}
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.2} data-id="element-41" data-mp="x0uyic0f6j3u">
          <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:items-start" data-id="element-42" data-mp="3lsypyre788fd">
            <a href={contact.whatsappHref} className="inline-flex w-full items-center justify-center rounded-full bg-brand-red px-12 py-5 font-display text-2xl tracking-[0.14em] text-white shadow-redGlow transition-[transform,box-shadow,background-color] duration-200 ease-smooth hover:scale-105 hover:bg-[#ff1008] hover:shadow-[0_0_60px_-4px_rgba(225,6,0,0.95)] focus:outline-none focus-visible:ring-2 focus-visible:ring-white sm:w-auto" data-id="element-43" data-mp="3hrd9yx6dbe0y">
              CONTACTAR
            </a>
            <p className="max-w-xs text-center font-sans text-xs leading-relaxed text-white/55 sm:text-left" data-id="element-44" data-mp="2g0c13g2gwgrw">
              Llamada sin costo adicional, aplica cargo según cada operador.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}